import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';
import styled, { css } from 'styled-components';

export const StyledContainer = styled(FlexBox)`
    background-color: ${({ theme }) => theme.colors.gs500};
    border-radius: 5px;
    min-width: 160px;
    width: 100%;

    ${media.sm(css`
        min-width: 208px;
    `)};
`;

export const StyledLazyLoadImage = styled(LazyLoadMedia)`
    & img {
        transition: transform ${speed.content} ease-in;
        border-radius: 5px;
    }

    &:hover img {
        transform: scale(1.1, 1.1);
    }
`;

export const StyledInfo = styled(FlexBox)`
    padding: 20px 20px 15px;

    span {
        text-align: center;
        margin-bottom: 5px;
    }
`;

export const StyledLink = styled.a`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding-right: 20px;
`;